import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=4225230c"
import script from "./SettingModal.vue?vue&type=script&lang=js"
export * from "./SettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports